import React from "react";
import { Container } from "reactstrap";
import Menu from "../../components/menu/Menu";
import FormAlterarSenha from "./components/FormAlterarSenha";

export default function AlterarSenha() {
    return (
        <>
            <Menu />
            <div className="App wrapper">
                <Container>
                    <div className="row">
                        <div className="col-sm-12">
                            <FormAlterarSenha />
                        </div>
                    </div>
                </Container>
            </div>
        </>
    );
}
